import userReducer from "./reducer/userReducer";
import albumReducer from "./reducer/albumsReducer";
import selectedSongReducer from "./reducer/selectedSongReducer";
import dialogReducer from "./reducer/dialogReducer";
import playListReduser from "./reducer/playListReducer";
import thunk from "redux-thunk";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { routerMiddleware, connectRouter } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import { all, fork } from "redux-saga/effects";
import { adminReducer, adminSaga, USER_LOGOUT } from "react-admin";
import tracksOfTheWeekReducer from "./reducer/tracksOfTheWeekReducer";
import playlistSaga from "./sagas";
import loadingReducer from "./reducer/loadingReducer";
import snackReducer from "./reducer/snackReducer";
import sideBarMenuReducer from "./reducer/sidebarMenuReducer";
export default ({ authProvider, dataProvider, history }) => {
  const reducer = combineReducers({
    admin: adminReducer,
    router: connectRouter(history),
    user: userReducer,
    playLists: playListReduser,
    albums: albumReducer,
    selectedSong: selectedSongReducer,
    isDialogOpened: dialogReducer,
    tracksOfTheWeek: tracksOfTheWeekReducer,
    loading: loadingReducer,
    app: snackReducer,
    sidebarMenu: sideBarMenuReducer,
  });
  const resettableAppReducer = (state, action) =>
    reducer(action.type !== USER_LOGOUT ? state : undefined, action);

  const saga = function* rootSaga() {
    yield all([adminSaga(dataProvider, authProvider), playlistSaga].map(fork));
  };
  const sagaMiddleware = createSagaMiddleware();

  const composeEnhancers =
    (process.env.NODE_ENV === "development" &&
      typeof window !== "undefined" &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
      })) ||
    compose;

  const store = createStore(
    resettableAppReducer,
    {
      user: { name: "", email: "" },
      playLists: {},
      albums: [{}, {}, {}, {}, {}, {}],
      selectedSong: {},
      isDialogOpened: false,
      tracksOfTheWeek: {},
    },
    composeEnhancers(
      applyMiddleware(
        sagaMiddleware,
        thunk,
        routerMiddleware(history)
        // add your own middlewares here
      )
      // add your own enhancers here
    )
  );
  sagaMiddleware.run(saga);
  return store;
};

// export default createStore(
//   combineReducers({
//     user: userReducer,
//     playLists: playListReduser,
//     albums: albumReducer,
//     selectedSong: selectedSongReducer,
//     isDialogOpened: dialogReducer,
//   }),
//   compose(
//     applyMiddleware(thunk),
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
//   )
// );
